import React from "react";
import { TooltipProps } from "recharts";

const CustomTooltip = ({ active, payload }: TooltipProps<number, string>) => {
  if (active && payload && payload.length) {
    const sentAmount = payload[0]?.payload?.amount;
    const controllerName = payload[0]?.payload?.name;

    return (
      <div className="tooltip-container data-box">
        <div className="column">
          <p>{controllerName}</p>
          <p className="amount">{sentAmount}</p>
        </div>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
